import { atom } from 'recoil';

export const recoilSelectedEmployers = atom({
  key: 'selectedEmployer',
  default: [] as string[], //employer names
});
